import { ShipmentTransportOrderMaterialListSearchCriteria } from '../../models/shipment-transport-order-materials.model';

export class ShipmentTransportOrderMaterialsLoad {
  constructor(public payload: ShipmentTransportOrderMaterialListSearchCriteria) {}
  public static readonly type = '[ShipmentTransportOrderMaterials] Materials Load';
}

export class ShipmentTransportOrderMaterialsInitialState {
  public static readonly type = '[ShipmentTransportOrderMaterials] Set Initial State';
}
